import { useMemo } from 'react';
import { Select } from '@backstage/ui';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import { appTranslationRef } from '../../../../core/i18n';
import type { GitLabEnvironment } from '../gitlab';

interface EnvSelectorProps {
  environments: GitLabEnvironment[];
  selected: string | null;
  onSelect: (env: string) => void;
}

export const EnvSelector = ({ environments, selected, onSelect }: EnvSelectorProps) => {
  const { t } = useTranslationRef(appTranslationRef);

  const options = useMemo(
    () => environments.map(env => ({ value: env.name, label: env.name })),
    [environments],
  );

  return (
    <Select
      label={t('dbExplorer.envSelector.label')}
      options={options}
      size="small"
      defaultValue={selected ?? undefined}
      onChange={value => {
        if (typeof value === 'string') {
          onSelect(value);
        }
      }}
    />
  );
};
